export const colors = {
  primary: "#581DD0",
  lightPrimary: "#B895FF",
  lighterPrimary: "#CDBBF1",
  nearWhite: "#FAFAFA",
  lighterGray: "#F5F5F5",
  lightGray: "#CDCDCD",
  gray: "#979797",
  darkGray: "#5A5A5A",
  nearBlack: "#2E2246",
  darkBackground: "#26232C",
  white: "#FFFFFF",
  green: "#219653",
  red: "#EB5757"
};
